import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { ProposalActivitySummaryDto } from '@lib/dto/proposal-activity.dto'
import type { ProposalFollowUpDto } from '@lib/dto/proposal-follow-up.dto'
import { proposalService } from '@/services/ProposalService'
import { proposalKeys } from '@/hooks/queryKeys'

/**
 * What the client did on their shared link for one version.
 *
 * Refetched when the window regains focus, the TanStack default, which is the
 * moment it matters: a salesperson coming back to the tab before a call.
 */
export function useProposalActivity(
  versionId: string,
): UseQueryResult<ProposalActivitySummaryDto> {
  return useQuery({
    queryKey: proposalKeys.activity(versionId),
    queryFn: () => proposalService.listActivity(versionId),
    enabled: versionId !== '',
  })
}

/** Accepted proposals with work left for later: next season's quotes. */
export function useProposalFollowUps(): UseQueryResult<ProposalFollowUpDto[]> {
  return useQuery({
    queryKey: proposalKeys.followUps(),
    queryFn: () => proposalService.listFollowUps(),
  })
}
